// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-tips[data-v-6473262c]{font-size:12px;color:#333}.title-tips span[data-v-6473262c]{color:#999}.iconfont-diy[data-v-6473262c],.iconfont[data-v-6473262c]{font-size:20px;line-height:18px}", ""]);
// Exports
module.exports = exports;
